import EmailOutlined from '@mui/icons-material/EmailOutlined';
import PhoneOutlined from '@mui/icons-material/PhoneOutlined';
import PlaceOutlined from '@mui/icons-material/PlaceOutlined';
import ScheduleOutlined from '@mui/icons-material/ScheduleOutlined';
import React__default from 'react';
import { Divider } from './Divider.js';
import './LabelledList.scss';

const LabelledList = ({ items, className, variant = 'text', headerComponent, isHeaderFullbleed, }) => {
    const isNumbered = variant === 'numbered';
    function iconForItemType(itemType) {
        switch (itemType) {
            case 'address':
                return React__default.createElement(PlaceOutlined, { fontSize: 'large' });
            case 'phone':
                return React__default.createElement(PhoneOutlined, { fontSize: 'large' });
            case 'email':
                return React__default.createElement(EmailOutlined, { fontSize: 'large' });
            case 'hours':
                return React__default.createElement(ScheduleOutlined, { fontSize: 'large' });
            default:
                return null;
        }
    }
    function titleForItem(item, index) {
        return (React__default.createElement("div", { className: 'labelled-list-item-title--rev' }, isNumbered ? (React__default.createElement("div", { className: 'labelled-list-number--rev' }, index + 1)) : (React__default.createElement(React__default.Fragment, null,
            item.iconType && iconForItemType(item.iconType),
            item.title))));
    }
    const listItems = items?.map((item, index) => (React__default.createElement("li", { key: index },
        index > 0 && index !== items.length && React__default.createElement(Divider, null),
        titleForItem(item, index),
        React__default.createElement("div", { className: 'labelled-list-item-content--rev' }, item.content))));
    return (React__default.createElement("div", { className: className, "data-rev-component": 'labelled-list', "data-rev-variant": variant },
        !!headerComponent && (React__default.createElement("div", { className: 'labelled-list-header--rev', "data-rev-isfullbleed": isHeaderFullbleed }, headerComponent)),
        isNumbered ? React__default.createElement("ol", null, listItems) : React__default.createElement("ul", null, listItems)));
};

export { LabelledList };
//# sourceMappingURL=LabelledList.js.map
